import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import MarketDetail from "@/pages/MarketDetail";
import Compare from "@/pages/Compare";
import InflationPage from "@/pages/InflationPage";
import ISMPage from "@/pages/ISMPage";
import NFPDetailPage from "@/pages/NFPDetailPage";
import DxySessionPage from "@/pages/DxySessionPage";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AlertsProvider } from "@/contexts/AlertsContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import LlmUsageFooter from "@/components/cot/LlmUsageFooter";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div
        className="min-h-screen bg-black text-zinc-600 flex items-center justify-center text-[10px] uppercase tracking-widest"
        data-testid="auth-loading"
      >
        Authenticating…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <>
      {children}
      <LlmUsageFooter />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <AlertsProvider>
            <BrowserRouter>
              <ErrorBoundary>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/market/:code"
                    element={
                      <ProtectedRoute>
                        <MarketDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/compare"
                    element={
                      <ProtectedRoute>
                        <Compare />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/inflation"
                    element={
                      <ProtectedRoute>
                        <InflationPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ism"
                    element={
                      <ProtectedRoute>
                        <ISMPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dxy"
                    element={
                      <ProtectedRoute>
                        <DxySessionPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/nfp"
                    element={
                      <ProtectedRoute>
                        <NFPDetailPage />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </ErrorBoundary>
            </BrowserRouter>
          </AlertsProvider>
        </AuthProvider>
      </ThemeProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#09090B",
            border: "1px solid #27272A",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            color: "#FAFAFA",
          },
        }}
      />
    </div>
  );
}

export default App;
